import { ListMessageSectionOption } from 'apps/whatsApp/ListMessages/types'
import { FlowChartButtonBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartButtonBuilder'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

import { FlowChartButtonStatsConverter } from './FlowChartButtonStatsConverter'

export class FlowChartButtonConverter {
  static fromListMessageSectionOption(option: ListMessageSectionOption): FlowChartButton {
    const { _oid: id, caption } = option

    return new FlowChartButtonBuilder(id)
      .withCaption(caption)
      .withIsInteractive(true)
      .withNextStep(new FlowChartNextStepBuilder(id).build())
      .withStats(FlowChartButtonStatsConverter.fromListMessageSectionOption(option))
      .build()
  }
}
